import React from "react";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";

const SessionQuantityInput = ({
  quantity,
  onChangeQuantity,
  isUnlimited,
  onToggleUnlimited,
  label = "Sessions Quantity",
  isPackage = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <span className={styles.session_quantity}>{label}</span>

      <div className={styles.quantity_border}>
        <button
          type="button"
          onClick={() => onChangeQuantity(Math.max((quantity || 1) - 1, 1))}
          className={styles.decrementButton}
          disabled={isUnlimited || quantity <= 1}
        >
          <i className="fas fa-minus fa-xs"></i>
        </button>

        <span>
          {isUnlimited ? <span className={styles.infinitySymbol}>&infin;</span> : quantity ?? 1}
        </span>

        <button
          type="button"
          onClick={() => onChangeQuantity((quantity || 1) + 1)}
          className={styles.incrementButton}
          disabled={isUnlimited}
        >
          <i className="fas fa-plus fa-xs"></i>
        </button>
      </div>

      <div className={styles.right_group}>
        {!isPackage ? (
          <>
            <span className={styles.unlimited_label}>{t('Unlimited')}</span>
            <label className={styles.switch}>
              <input
                type="checkbox"
                checked={isUnlimited}
                onChange={(e) => onToggleUnlimited(e.target.checked)}
              />
              <span className={styles.slider}></span>
            </label>
          </>
        ) : (
          <div className={styles.unlimited_placeholder}></div>
        )}
      </div>
    </>
  );
};

export default SessionQuantityInput;
